import { Controller } from "@hotwired/stimulus";
import { Tooltip } from "bootstrap";

export default class extends Controller {
  connect() {
    this.tooltip = new Tooltip(this.element);
  }

  // Le righe sostituite da turbo stream non devono lasciare tooltip aperti nella pagina.
  disconnect() {
    this.tooltip?.dispose();
  }
}
